/* The bag's item count on the browser tab (after Coffee Supreme): the favicon redrawn with a small counter, and optionally "(2)" before the page title. Browsers that ignore favicon changes simply keep the plain icon. */
(() => {
  const script = document.currentScript;
  const counter = document.querySelector('[data-cart-count]');
  let link = document.querySelector('link[rel~="icon"]');
  if (!counter || !link) return;
  const original = link.href;
  const title = document.title;
  const withTitle = script?.dataset.mode === 'icon_title';
  const icon = new Image();
  icon.crossOrigin = 'anonymous';
  const draw = () => {
    const count = Number(counter.textContent) || 0;
    if (withTitle) document.title = count ? `(${count}) ${title}` : title;
    let href = original;
    if (count && icon.naturalWidth) {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = canvas.height = 64;
        const pen = canvas.getContext('2d');
        pen.drawImage(icon, 0, 0, 64, 64);
        /* A black disc with a white ring, bottom right, so it separates from the icon and from dark tab bars. */
        pen.beginPath();
        pen.arc(43, 43, 21, 0, Math.PI * 2);
        pen.fillStyle = '#fff';
        pen.fill();
        pen.beginPath();
        pen.arc(43, 43, 18, 0, Math.PI * 2);
        pen.fillStyle = '#111';
        pen.fill();
        pen.fillStyle = '#fff';
        pen.font = `bold ${count > 9 ? 22 : 26}px Arial, sans-serif`;
        pen.textAlign = 'center';
        pen.textBaseline = 'middle';
        pen.fillText(count > 9 ? '9+' : String(count), 43, 45);
        href = canvas.toDataURL('image/png');
      } catch (error) {
        /* An icon that cannot be read back (no cross-origin permission) stays as it is. */
      }
    }
    if (href === link.href) return;
    /* A fresh element rather than a new href: some browsers only notice a replaced link. */
    const next = link.cloneNode();
    next.href = href;
    link.replaceWith(next);
    link = next;
  };
  icon.addEventListener('load', draw);
  icon.src = original;
  new MutationObserver(draw).observe(counter, {
    childList: true,
    characterData: true,
    subtree: true,
  });
})();
